<template>
  <div v-loading="loading">
    <h3>{{ $t("lang.networkMonitoring.configuration") }}</h3>
    <el-button size="mini" type="primary" class="refresh" @click="refresh">刷新</el-button>
    <el-divider></el-divider>
    <el-form :model="networkFormObj" ref="network" :rules="rules" label-width="120px">
      <!-- 已启用 -->
      <el-form-item :label="$t('lang.networkMonitoring.enabled')">
        <el-switch v-model="networkFormObj.enabled"></el-switch>
      </el-form-item>
      <!-- 操作模式 -->
      <el-form-item :label="$t('lang.networkMonitoring.operatingMode')">
        <el-select v-model="networkFormObj.mode" size="mini" class="input_item"
          :placeholder="$t('lang.networkMonitoring.pleaseChoose')">
          <el-option :label="$t('lang.networkMonitoring.restartAfterNetworkDisconnection')
            " value="ping"></el-option>
          <el-option :label="$t('lang.networkMonitoring.periodicRestart')" value="allways"></el-option>
        </el-select>
      </el-form-item>
      <!-- 重复周期 -->
      <el-form-item :label="$t('lang.networkMonitoring.repeatCycle')" v-if="networkFormObj.mode == 'allways'">
        <el-input v-model="networkFormObj.period" size="mini" class="input_item"
          :placeholder="$t('lang.networkMonitoring.pleaseEnter')"></el-input>
      </el-form-item>
      <!-- 检测地址 -->
      <el-form-item prop="pinghosts" :label="$t('lang.networkMonitoring.detectionAddress')"
        v-if="networkFormObj.mode == 'ping'">
        <div class="input_box">
          <div class="input_list" v-for="(i, index) in networkFormObj.pinghosts">
            <el-input v-model="networkFormObj.pinghosts[index]" size="mini" class="input_item"
              :placeholder="$t('lang.networkMonitoring.pleaseEnter')"></el-input>
            <el-button v-if="networkFormObj.pinghosts.length - 1 === index" size="mini" type="primary"
              @click="addPingHost" icon="el-icon-plus" circle></el-button>
            <el-button v-if="networkFormObj.pinghosts.length > 1 &&
              index != networkFormObj.pinghosts.length - 1
              " size="mini" type="danger" @click="delPingHost(index)" icon="el-icon-minus" circle></el-button>
          </div>
        </div>
      </el-form-item>
      <!-- 检测周期 -->
      <el-form-item prop="pingperiod" :label="$t('lang.networkMonitoring.detectionCycle')"
        v-if="networkFormObj.mode == 'ping'">
        <el-input class="input_item" v-model="networkFormObj.pingperiod" size="mini"
          :placeholder="$t('lang.networkMonitoring.pleaseEnter')"></el-input>
        <p class="tips">
          {{ $t("lang.networkMonitoring.tips1") }}
        </p>
      </el-form-item>
      <!-- 恢复周期 -->
      <el-form-item :label="$t('lang.networkMonitoring.recoveryPeriod')" v-if="networkFormObj.mode == 'ping'">
        <el-input class="input_item" v-model="networkFormObj.period" size="mini"
          :placeholder="$t('lang.networkMonitoring.pleaseEnter')"></el-input>
        <p class="tips">
          {{ $t("lang.networkMonitoring.tips2") }}
        </p>
      </el-form-item>
    </el-form>
    <div class="btn_box">
      <el-button type="primary" @click="saveNetwork">{{
        $t("lang.networkMonitoring.save")
      }}</el-button>
    </div>
  </div>
</template>

<script>
import { listConfig, updateConfig } from "@/api/configurationlist";
import { progressControl } from "@/api/particulars";
export default {
  name: "",
  props: ["deviceSn", "deviceDid"],
  data() {
    var checkIP = (rule, value, callback) => {
      if (value.length == 0) {
        callback(new Error('请输入检测地址'))
      } else {
        for (let i = 0; i < value.length; i++) {
          if (!value[i].match(/^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){6}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^::([\da-fA-F]{1,4}:){0,4}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:):([\da-fA-F]{1,4}:){0,3}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){2}:([\da-fA-F]{1,4}:){0,2}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){3}:([\da-fA-F]{1,4}:){0,1}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){4}:((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}$|^:((:[\da-fA-F]{1,4}){1,6}|:)$|^[\da-fA-F]{1,4}:((:[\da-fA-F]{1,4}){1,5}|:)$|^([\da-fA-F]{1,4}:){2}((:[\da-fA-F]{1,4}){1,4}|:)$|^([\da-fA-F]{1,4}:){3}((:[\da-fA-F]{1,4}){1,3}|:)$|^([\da-fA-F]{1,4}:){4}((:[\da-fA-F]{1,4}){1,2}|:)$|^([\da-fA-F]{1,4}:){5}:([\da-fA-F]{1,4})?$|^([\da-fA-F]{1,4}:){6}:$/)) {
            callback(new Error('请输入正确的IP地址'))
            break
          }
        }
        callback()
      }
    }
    return {
      networkFormObj: {
        enabled: false,
        mode: "ping",
        pinghosts: [],
        pingperiod: 60,
        period: "10m",
      },
      loading: true,
      rules: {
        pingperiod: [
          { required: true, message: "请输入检测周期", trigger: "blur" },
          {
            pattern: /^[1-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur",
          },
        ],
        pinghosts: [
          { validator: checkIP, message: "请输入正确的检测地址", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    addPingHost() {
      this.networkFormObj.pinghosts.push("");
    },
    delPingHost(index) {
      this.networkFormObj.pinghosts.splice(index, 1);
    },
    getConfig() {
      return new Promise((resolve, reject) => {
        listConfig(this.deviceSn, this.deviceDid, [
          {
            section: "watchcat",
            config: "system",
            options: [
              { option: "enabled" },
              { option: "mode" },
              { option: "pingperiod" },
              { option: "period" },
              { option: "pinghosts" },
            ],
            lists: [{ list: "pinghosts" }],
          },
        ]).then((res) => {
          if (res.data.code == 0) {
            this.networkFormObj = res.data.data.mess[0].s_objects[0].options;
            if (res.data.data.mess[0].s_objects[0].options.pinghosts) {
              res.data.data.mess[0].s_objects[0].lists.pinghosts.push(
                res.data.data.mess[0].s_objects[0].options.pinghosts
              );
            }
            this.$set(
              this.networkFormObj,
              "pinghosts",
              res.data.data.mess[0].s_objects[0].lists.pinghosts.length == 0
                ? [""]
                : res.data.data.mess[0].s_objects[0].lists.pinghosts
            );
            this.networkFormObj.enabled =
              this.networkFormObj.enabled == "1" ? true : false;
          } else {
            this.$message.error(this.$t("lang.networkMonitoring.msg1"));
          }
          resolve();
        });
      });
    },
    saveNetwork() {
      this.$refs.network.validate((valid) => {
        if (valid) {
          this.loading = true;
          updateConfig(this.deviceSn, this.deviceDid, [
            {
              section: "watchcat",
              config: "system",
              action: 0,
              index: [0],
              options: {
                enabled: this.networkFormObj.enabled ? "1" : "0",
                mode: this.networkFormObj.mode,
                pingperiod: this.networkFormObj.pingperiod,
                period: this.networkFormObj.period,
              },
              lists: {
                pinghosts: this.networkFormObj.pinghosts,
              },
            },
          ]).then(async (res) => {
            if (res.data.code == 0) {
              this.$message.success(this.$t("lang.networkMonitoring.msg2"));
              await progressControl([
                {
                  process: 'watchcat',
                  type: 0,
                  action: 'restart'
                }
              ], this.deviceDid, this.deviceSn)
            } else {
              this.$message.error(this.$t("lang.networkMonitoring.msg3"));
            }
            this.loading = false;
          });
        } else {
          this.$message.error(this.$t("lang.networkMonitoring.msg4"));
          return false;
        }
      });

    },
    async refresh() {
      await this.getConfig();
      this.loading = false;
    },
  },
  async mounted() {
    if (this.deviceSn && this.deviceDid) {
      await this.getConfig();
      this.loading = false;
    } else {
      this.$message.error(this.$t("lang.taskDialog.please"));
    }
  },
};
</script>
<style scoped>
h3 {
  font-size: 18px;
}

.input_list {
  display: flex;
  align-items: center;
}

.input_item {
  width: 240px;
  margin-right: 10px;
}

.input_box {
  display: flex;
  flex-direction: column;
}

.tips {
  color: #999;
  font-size: 12px;
}

.btn_box {
  float: right;
}

.refresh {
  float: right;
  transform: translateY(-20px);
}
</style>
